import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "return-arrow",
  "use": "return-arrow-usage",
  "viewBox": "0 0 11 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 11 17\" id=\"return-arrow\"><path fill=\"#0076c0\" d=\"M10.727 9c0 .422-.329.75-.727.75H2.805l2.46 2.484a.723.723 0 0 1 0 1.055.73.73 0 0 1-.515.211.74.74 0 0 1-.54-.21L.46 9.54a.723.723 0 0 1 0-1.056l3.75-3.75a.723.723 0 0 1 1.056 0 .723.723 0 0 1 0 1.055L2.805 8.25H10c.398 0 .727.352.727.75\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol